export const twoDecimalFormat = new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const commaFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
export const currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
